<template>
  <MainLayout selectMenu="1-1" sideBar="machine" sidebarMenu="11-1">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else>
      <Row type="flex" justify="start" align="middle" class="status-bar menu-actions">
        <Col flex="1">
        <div class="status-title">{{ getTranslation('r001') }}</div>
        </Col>
        <Col flex="1" class="radio-buttons-col">
        <Row class="radio-buttons-row" type="flex">
          <Col flex="1" class="flex-middle">
          <Radio label="" disabled :class="{ 'custom-radio-checked': mode1, 'custom-radio-unchecked': !mode1 }"></Radio>
          </Col>
          <Col flex="1" class="flex-middle">
          <Radio label="" disabled :class="{ 'custom-radio-checked': mode2, 'custom-radio-unchecked': !mode2 }"></Radio>
          </Col>
        </Row>
        <Row class="radio-labels-row">
          <Col flex="1" class="flex-middle"><span>{{ getTranslation('r002') }}</span></Col>
          <Col flex="1" class="flex-middle"><span>{{ getTranslation('r003') }}</span></Col>
        </Row>
        <div class="flex-middle">
          <Button type="primary" size="small" class="action-btn" @click.native="workMode()"
            :loading="modeLoadding[0]">{{
              getTranslation('r002') }}/{{ getTranslation('r003')
            }}</Button>
        </div>
        </Col>
        <Col flex="1" class="radio-buttons-col">
        <Row class="radio-buttons-row" type="flex">
          <Col flex="1" class="flex-middle">
          <Radio label="" disabled :class="{ 'custom-radio-checked': mode3, 'custom-radio-unchecked': !mode3 }"></Radio>
          </Col>
          <Col flex="1" class="flex-middle">
          <Radio label="" disabled :class="{ 'custom-radio-checked': mode4, 'custom-radio-unchecked': !mode4 }"></Radio>
          </Col>
        </Row>
        <Row class="radio-labels-row">
          <Col flex="1" class="flex-middle"><span>{{ getTranslation('r004') }}</span></Col>
          <Col flex="1" class="flex-middle"><span>{{ getTranslation('r005') }}</span></Col>
        </Row>
        <div class="flex-middle">
          <Button type="primary" size="small" class="action-btn" @click.native="weldMode()"
            :loading="modeLoadding[1]">{{
              getTranslation('r004') }}/{{ getTranslation('r005')
            }}</Button>
        </div>
        </Col>
        <Col flex="1" class="radio-buttons-col">
        <Row class="radio-buttons-row" type="flex">
          <Col flex="1" class="flex-middle">
          <Radio label="" disabled :class="{ 'custom-radio-checked': mode5, 'custom-radio-unchecked': !mode5 }"></Radio>
          </Col>
          <Col flex="1" class="flex-middle">
          <Radio label="" disabled :class="{ 'custom-radio-checked': mode6, 'custom-radio-unchecked': !mode6 }"></Radio>
          </Col>
        </Row>
        <Row class="radio-labels-row">
          <Col flex="1" class="flex-middle"><span>{{ getTranslation('r006') }}</span></Col>
          <Col flex="1" class="flex-middle"><span>{{ getTranslation('r007') }}</span></Col>
        </Row>
        <div class="flex-middle">
          <Button type="primary" size="small" class="action-btn" @click.native="pressMode()"
            :loading="modeLoadding[2]">{{
              getTranslation('r006') }}/{{ getTranslation('r007')
            }}</Button>
        </div>
        </Col>
        <Col flex="1">
        <Row type="flex">
          <Col flex="1" class="flex-middle normal-cursor" @click.native="showWarnList()">
          <img v-if="!showWarn" :src="require('@/assets/img/switch-warn-black.png')" />
          <img v-if="showWarn" :src="require('@/assets/img/switch-warn-red.png')" class="only-hover"/></Col>
        </Row>
        <Row type="flex">
          <Col flex="1" class="flex-middle"><span>{{ getTranslation('r008') }}</span></Col>
        </Row>
        </Col>
        <Col flex="6">
        <Button type="primary" size="small" @click.native="toAlarm()">{{ getTranslation('r009') }}</Button>
        </Col>
      </Row>
      <Tabs v-model="selectTab" type="card" class="custom-tabs">
        <TabPane :label="getTranslation('k001')" name="m1" class="custom-tabpane">
          <Row type="flex" align="middle" class="spec-row">
            <Col flex="1" class="spec-content">
            <span class="spec-item">{{ getTranslation('k258') }}:<Input type="text" style="width:150px" size="small"
                class="spec-input" v-model="selectLibrary.SpotModel" disabled /></span>
            <span class="spec-item">{{ getTranslation('k259') }}:<Input type="text" size="small" style="width:200px"
                class="spec-input" v-model="selectLibrary.SpotId" disabled /></span>
            <span class="spec-item">{{ getTranslation('b006') }}:<Input type="text" size="small" style="width:50px"
                class="spec-input" v-model="selectLibrary.NoWeldProgram" disabled /></span>
            <span class="spec-item">{{ getTranslation('b007') }}:<Input type="text" size="small" style="width:100px"
                class="spec-input" disabled v-model="selectLibrary.WeldProgram" /></span>
            <span class="spec-item">{{ getTranslation('k243') }}:<Input type="text" size="small" style="width:100px"
                class="spec-input" v-model="selectLibrary.SpotPss" disabled /></span>
            <span class="spec-item">{{ getTranslation('k244') }}:<Input type="text" size="small" style="width:100px"
                class="spec-input" v-model="selectLibrary.SpotThk" disabled /></span>
            <span class="spec-item">{{ getTranslation('k241') }}:<Input type="text" size="small" style="width:200px"
                class="spec-input" v-model="selectLibrary.SpotName" disabled /></span>
            </Col>
          </Row>
          <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('r013') }}</div>
            <div class="">
              <Row type="flex" class="vin-header">
                <Col flex="1" class="vin-cell">{{ getTranslation('k230') }}</Col>
                <Col flex="1" class="vin-cell">{{ getTranslation('r014') }}</Col>
                <Col flex="1" class="vin-cell">{{ getTranslation('r015') }}</Col>
                <Col flex="1" class="vin-cell">{{ getTranslation('r016') }}</Col>
                <Col flex="1" class="vin-cell">{{ getTranslation('r017') }}</Col>
                <Col flex="1" class="vin-cell">{{ getTranslation('r018') }}</Col>
                <Col flex="1" class="vin-cell">{{ getTranslation('r019') }}</Col>
                <Col flex="1" class="vin-cell">{{ getTranslation('r020') }}</Col>
              </Row>
              <Row type="flex" class="row-data">
                <Col flex="1" class="vin-cell">{{ selectLibrary.ValCurrentGun }}
                </Col>
                <Col flex="1" class="vin-cell">
                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{
                  selectLibrary.ValGun1SingleProdSpotCnt }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{
                  selectLibrary.ValGun2SingleProdSpotCnt }}</template>
                <template v-else>-</template>
                </Col>
                <Col flex="1" class="vin-cell">
                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{
                  selectLibrary.ValGun1ScheduleProdMfgCnt }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{
                  selectLibrary.ValGun2ScheduleProdMfgCnt }}</template>
                <template v-else>-</template>
                </Col>
                <Col flex="1" class="vin-cell">
                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{
                  selectLibrary.ValGun1TotalProdMfgCnt }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{
                  selectLibrary.ValGun2TotalProdMfgCnt }}</template>
                <template v-else>-</template>
                </Col>
                <Col flex="1" class="vin-cell">
                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{
                  selectLibrary.ValGun1TotalProdSpotCnt }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{
                  selectLibrary.ValGun2TotalProdSpotCnt }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 3">{{
                  selectLibrary.ValGun3TotalProdSpotCnt }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 4">{{
                  selectLibrary.ValGun4TotalProdSpotCnt }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 5">{{
                  selectLibrary.ValGun5TotalProdSpotCnt }}</template>
                <template v-else>-</template>
                </Col>
                <Col flex="1" class="vin-cell">
                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{ selectLibrary.ValGun1StepIncNumCnt
                  }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{
                  selectLibrary.ValGun2StepIncNumCnt }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 3">{{
                  selectLibrary.ValGun3StepIncNumCnt }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 4">{{
                  selectLibrary.ValGun4StepIncNumCnt }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 5">{{
                  selectLibrary.ValGun5StepIncNumCnt }}</template>
                <template v-else>-</template>
                </Col>
                <Col flex="1" class="vin-cell">
                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{ selectLibrary.ValGun1DressedNumCnt
                  }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{
                  selectLibrary.ValGun2DressedNumCnt }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 3">{{
                  selectLibrary.ValGun3DressedNumCnt }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 4">{{
                  selectLibrary.ValGun4DressedNumCnt }}</template>
                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 5">{{
                  selectLibrary.ValGun5DressedNumCnt }}</template>
                <template v-else>-</template>
                </Col>
                <Col flex="1" class="vin-cell">{{ selectLibrary.ValPrimCapVolt }}
                </Col>
              </Row>
            </div>
          </Card>
          <div class="separator-section">
            <div class="separator-line"></div>
          </div>
          <div class="other-line bordered-section">
            <Row type="flex" class="row-line table-row-odd">
              <Col flex="1">
              </Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 1 }]">
              {{ getTranslation('b018') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 2 }]">
              {{ getTranslation('b019') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 3 }]">
              {{ getTranslation('b020') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 4 }]">
              {{ getTranslation('b021') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 5 }]">
              {{ getTranslation('b022') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 6 }]">
              {{ getTranslation('b023') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 7 }]">
              {{ getTranslation('b024') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 8 }]">
              {{ getTranslation('b025') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 9 }]">
              {{ getTranslation('b026') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 10 }]">
              {{ getTranslation('b027') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 11 }]">
              {{ getTranslation('b028') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 12 }]">
              {{ getTranslation('b029') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 13 }]">
              {{ getTranslation('b030') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 14 }]">
              {{ getTranslation('b031') }}</Col>
              <Col flex="1"
                :class="['flex-middle', { 'in-progroess': selectLibrary.ValCurrentPhase && selectLibrary.ValCurrentPhase >= 15 }]">
              {{ getTranslation('b032') }}</Col>
              <Col flex="1">
              </Col>
            </Row>
            <Row type="flex" class="row-line ">
              <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-crr.png')" /></Col>
              <Col flex="2">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.CrrPreWeld">
              </Col>
              <Col flex="2">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.CrrWeld1">
              </Col>
              <Col flex="1">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.CrrWeld2">
              </Col>
              <Col flex="1">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.CrrWeld3">
              </Col>
              <Col flex="2">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.CrrPostWeld">
              </Col>
              <Col flex="2">
              </Col>
              <Col flex="1">KA</Col>
            </Row>
            <Row type="flex" class="row-line table-row-odd">
              <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-time.png')" /></Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimPrePress">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimMorePress">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimPreWeld">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimCold0">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimAscentWeld">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimWeld1">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimCold1">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimWeld2">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimCold2">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimWeld3">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimDescendWeld">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimCold3">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimPostWeld">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimKeep">
              </Col>
              <Col flex="1" class="flex-middle" v-html="selectLibrary.TimRelease">
              </Col>
              <Col flex="1"><template v-if="kind == 62">cyc</template><template v-else>ms</template></Col>
            </Row>
          </div>
          <div class="separator-section">
            <div class="separator-line"></div>
          </div>
          <div class="bordered-section vin-section">
            <Row type="flex" class="vin-header">
              <Col flex="1" class="vin-cell">{{ getTranslation('k226') }}</Col>

              <Col flex="1" class="vin-cell">{{ getTranslation('k231') }}</Col>
              <Col flex="1" class="vin-cell">{{ getTranslation('k232') }}</Col>
              <Col flex="1" class="vin-cell">{{ getTranslation('r021') }}</Col>
              <Col flex="1" class="vin-cell">{{ getTranslation('r022') }}</Col>
              <Col flex="1" class="vin-cell">{{ getTranslation('k233') }}</Col>
              <Col flex="1" class="vin-cell">{{ getTranslation('k234') }}</Col>
              <Col flex="1" class="vin-cell">{{ getTranslation('k235') }}</Col>
            </Row>
            <Row type="flex" class="vin-data">
              <Col flex="1" class="vin-cell">{{ selectLibrary.ValVIN }}
              </Col>
              <Col flex="1" class="vin-cell">{{ selectLibrary.ValPowerCnt }}
              </Col>
              <Col flex="1" class="vin-cell">{{ selectLibrary.ValDutyOnTime }}
              </Col>
              <Col flex="1" class="vin-cell">{{ selectLibrary.ValPrgExpulsionCnt }}
              </Col>
              <Col flex="1" class="vin-cell">{{ selectLibrary.ValSysExpulsionCnt }}
              </Col>
              <Col flex="1" class="vin-cell">{{ selectLibrary.ValSecVolt }}
              </Col>
              <Col flex="1" class="vin-cell">{{ selectLibrary.ValSecRest }}
              </Col>
              <Col flex="1" class="vin-cell">{{ selectLibrary.DispRsv10 }}
              </Col>
            </Row>
          </div>
        </TabPane>
        <TabPane :label="getTranslation('r010')" name="m2" class="custom-tabpane">
          <Row type="flex" align="middle" class="spec-row">
            <Col flex="1" class="spec-content">
            <span class="spec-item">{{ getTranslation('k258') }}:<Input type="text" style="width:150px" size="small"
                class="spec-input" v-model="selectLibrary.SpotModel" disabled /></span>
            <span class="spec-item">{{ getTranslation('k259') }}:<Input type="text" size="small" style="width:200px"
                class="spec-input" v-model="selectLibrary.SpotId" disabled /></span>
            <span class="spec-item">{{ getTranslation('b006') }}:<Input type="text" size="small" style="width:50px"
                class="spec-input" v-model="selectLibrary.NoWeldProgram" disabled /></span>
            <span class="spec-item">{{ getTranslation('b007') }}:<Input type="text" size="small" style="width:100px"
                class="spec-input" disabled v-model="selectLibrary.WeldProgram" /></span>
            <span class="spec-item">{{ getTranslation('k243') }}:<Input type="text" size="small" style="width:100px"
                class="spec-input" v-model="selectLibrary.SpotPss" disabled /></span>
            <span class="spec-item">{{ getTranslation('k244') }}:<Input type="text" size="small" style="width:100px"
                class="spec-input" v-model="selectLibrary.SpotThk" disabled /></span>
            <span class="spec-item">{{ getTranslation('k241') }}:<Input type="text" size="small" style="width:200px"
                class="spec-input" v-model="selectLibrary.SpotName" disabled /></span>
            </Col>
          </Row>
          <Row type="flex">
            <Col flex="1">
            <Card class="card-container little-card" dis-hover>
              <div slot="title" class="card-title">{{ getTranslation('r028') }}</div>
              <Row type="flex">
                <Col flex="1">
                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b0)]"></div>
                  <div class="custom-label">{{ getTranslation('r030') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b1)]"></div>
                  <div class="custom-label">{{ getTranslation('r031') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b2)]"></div>
                  <div class="custom-label">{{ getTranslation('r032') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b3)]"></div>
                  <div class="custom-label">{{ getTranslation('r033') }}</div>
                  </Col>
                </Row>

                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b4)]"></div>
                  <div class="custom-label">{{ getTranslation('r034') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b5)]"></div>
                  <div class="custom-label">{{ getTranslation('r035') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b6)]"></div>
                  <div class="custom-label">{{ getTranslation('r036') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b7)]"></div>
                  <div class="custom-label">{{ getTranslation('r037') }}</div>
                  </Col>
                </Row>
                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b8, true)]"></div>
                  <div class="custom-label "><span class="label-custom-warn">{{ getTranslation('r005') }}</span> / <span
                      class="label-custom-primary">{{ getTranslation('r004') }}</span></div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b9)]"></div>
                  <div class="custom-label">{{ getTranslation('r039') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b10, true)]"></div>
                  <div class="custom-label"><span class="label-custom-warn">{{ getTranslation('r002') }}</span> / <span
                      class="label-custom-primary">{{ getTranslation('r003') }}</span></div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b11)]"></div>
                  <div class="custom-label">{{ getTranslation('r041') }}</div>
                  </Col>
                </Row>
                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b12)]"></div>
                  <div class="custom-label">{{ getTranslation('r042') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b13)]"></div>
                  <div class="custom-label">{{ getTranslation('r043') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b14)]"></div>
                  <div class="custom-label">{{ getTranslation('r044') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b15)]"></div>
                  <div class="custom-label">{{ getTranslation('r045') }}</div>
                  </Col>
                </Row>
                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b16)]"></div>
                  <div class="custom-label">{{ getTranslation('r046') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b17)]"></div>
                  <div class="custom-label">{{ getTranslation('r047') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b18)]"></div>
                  <div class="custom-label">{{ getTranslation('r048') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b19)]"></div>
                  <div class="custom-label">{{ getTranslation('r047') }}</div>
                  </Col>
                </Row>
                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b20)]"></div>
                  <div class="custom-label">{{ getTranslation('k070') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b21)]"></div>
                  <div class="custom-label">{{ getTranslation('r006') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b22)]"></div>
                  <div class="custom-label">{{ getTranslation('r049') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b23)]"></div>
                  <div class="custom-label">{{ getTranslation('r050') }}</div>
                  </Col>
                </Row>
                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b24)]"></div>
                  <div class="custom-label">{{ getTranslation('r051') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b25)]"></div>
                  <div class="custom-label">{{ getTranslation('r052') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b26)]"></div>
                  <div class="custom-label">{{ getTranslation('r053') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b27)]"></div>
                  <div class="custom-label">{{ getTranslation('r054') }}</div>
                  </Col>
                </Row>

                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b28)]"></div>
                  <div class="custom-label">{{ getTranslation('r117') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b29)]"></div>
                  <div class="custom-label">{{ getTranslation('r056') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b30)]"></div>
                  <div class="custom-label">{{ getTranslation('r057') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(inputStatus && inputStatus.b31)]"></div>
                  <div class="custom-label">{{ getTranslation('r058') }}</div>
                  </Col>
                </Row>
                </Col>
              </Row>
            </Card>
            </Col>
            <Col flex="1">
            <Card class="card-container" dis-hover>
              <div slot="title" class="card-title">{{ getTranslation('r029') }}</div>
              <Row type="flex">
                <Col flex="1">
                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b0)]"></div>
                  <div class="custom-label">{{ getTranslation('r059') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b1)]"></div>
                  <div class="custom-label">{{ getTranslation('r060') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b2)]"></div>
                  <div class="custom-label">{{ getTranslation('r061') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b3)]"></div>
                  <div class="custom-label">{{ getTranslation('r062') }}</div>
                  </Col>
                </Row>

                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b4)]"></div>
                  <div class="custom-label">{{ getTranslation('r063') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b5)]"></div>
                  <div class="custom-label">{{ getTranslation('r064') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b6)]"></div>
                  <div class="custom-label">{{ getTranslation('r065') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b7, true)]"></div>
                  <div class="custom-label"><span class="label-custom-warn">{{ getTranslation('r005') }}</span> / <span
                      class="label-custom-primary">{{ getTranslation('r004') }}</span></div>
                  </Col>
                </Row>
                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b8)]"></div>
                  <div class="custom-label">{{ getTranslation('r066') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b9)]"></div>
                  <div class="custom-label">{{ getTranslation('r067') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b10)]"></div>
                  <div class="custom-label">{{ getTranslation('r068') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b11)]"></div>
                  <div class="custom-label">{{ getTranslation('r047') }}</div>
                  </Col>
                </Row>
                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b12)]"></div>
                  <div class="custom-label">{{ getTranslation('r069') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b13)]"></div>
                  <div class="custom-label">{{ getTranslation('r047') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b14)]"></div>
                  <div class="custom-label">{{ getTranslation('r070') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b15)]"></div>
                  <div class="custom-label">{{ getTranslation('r047') }}</div>
                  </Col>
                </Row>
                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b16)]"></div>
                  <div class="custom-label">{{ getTranslation('r047') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b17)]"></div>
                  <div class="custom-label">{{ getTranslation('r047') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b18)]"></div>
                  <div class="custom-label">{{ getTranslation('r071') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b19)]"></div>
                  <div class="custom-label">{{ getTranslation('r072') }}</div>
                  </Col>
                </Row>
                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b20)]"></div>
                  <div class="custom-label">{{ getTranslation('r116') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b21)]"></div>
                  <div class="custom-label">{{ getTranslation('r074') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b22)]"></div>
                  <div class="custom-label">{{ getTranslation('r075') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b23)]"></div>
                  <div class="custom-label">{{ getTranslation('r076') }}</div>
                  </Col>
                </Row>
                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b24)]"></div>
                  <div class="custom-label">{{ getTranslation('r077') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b25)]"></div>
                  <div class="custom-label">{{ getTranslation('r078') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b26)]"></div>
                  <div class="custom-label">{{ getTranslation('r079') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b27)]"></div>
                  <div class="custom-label">{{ getTranslation('r080') }}</div>
                  </Col>
                </Row>

                <Row type="flex" class="table-row-odd">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b28)]"></div>
                  <div class="custom-label">{{ getTranslation('r055') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b29)]"></div>
                  <div class="custom-label">{{ getTranslation('r056') }}</div>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b30)]"></div>
                  <div class="custom-label">{{ getTranslation('r057') }}</div>
                  </Col>
                  <Col flex="1" class="normal-hover">
                  <div :class="['my-custom-dot', getIOClass(outputStatus && outputStatus.b31)]"></div>
                  <div class="custom-label">{{ getTranslation('r058') }}</div>
                  </Col>
                </Row>
                </Col>
              </Row>
            </Card>
            </Col>
          </Row>
        </TabPane>
        <TabPane :label="getTranslation('r011')" name="m3" class="custom-tabpane">
          <Row type="flex" align="middle" class="spec-row">
            <Col flex="1" class="spec-content">
            <span class="spec-item">{{ getTranslation('k258') }}:<Input type="text" style="width:150px" size="small"
                class="spec-input" v-model="selectLibrary.SpotModel" disabled /></span>
            <span class="spec-item">{{ getTranslation('k259') }}:<Input type="text" size="small" style="width:200px"
                class="spec-input" v-model="selectLibrary.SpotId" disabled /></span>
            <span class="spec-item">{{ getTranslation('b006') }}:<Input type="text" size="small" style="width:50px"
                class="spec-input" v-model="selectLibrary.NoWeldProgram" disabled /></span>
            <span class="spec-item">{{ getTranslation('b007') }}:<Input type="text" size="small" style="width:100px"
                class="spec-input" disabled v-model="selectLibrary.WeldProgram" /></span>
            <span class="spec-item">{{ getTranslation('k243') }}:<Input type="text" size="small" style="width:100px"
                class="spec-input" v-model="selectLibrary.SpotPss" disabled /></span>
            <span class="spec-item">{{ getTranslation('k244') }}:<Input type="text" size="small" style="width:100px"
                class="spec-input" v-model="selectLibrary.SpotThk" disabled /></span>
            <span class="spec-item">{{ getTranslation('k241') }}:<Input type="text" size="small" style="width:200px"
                class="spec-input" v-model="selectLibrary.SpotName" disabled /></span>
            </Col>
          </Row>
          <Row type="flex">
            <Col flex="1" class="chart-tip flex-middle">
            {{ getTranslation('r114') }}
            </Col>
          </Row>
          <div ref="runningEcharts" :style="{ width: chartWidth, height: '550px' }"></div>
        </TabPane>
        <TabPane :label="getTranslation('r012')" name="m4" class="custom-tabpane">
          <Row type="flex" class="normal-row">
            <Col flex="1" class="flex-middle">{{ getTranslation('r023') }}</Col>
            <Col flex="3"><Input type="text" size="small" disabled v-model="ValControllerHWVer" style="width:30%" />
            </Col>
            <Col flex="1" class="flex-middle">{{ getTranslation('r024') }}</Col>
            <Col flex="3"><Input type="text" size="small" disabled v-model="ValControllerSWVer" style="width:30%" />
            </Col>
          </Row>
          <Row type="flex" class="normal-row">
            <Col flex="1" class="flex-middle">{{ getTranslation('r025') }}</Col>
            <Col flex="3"><Input type="text" size="small" disabled v-model="ValControllerCpldSWVer" style="width:30%" />
            </Col>
            <Col flex="1" class="flex-middle">{{ getTranslation('r026') }}</Col>
            <Col flex="3"><Input type="text" size="small" disabled v-model="CofGun1RogowskiSamp" style="width:30%" />
            </Col>
          </Row>
        </TabPane>
      </Tabs>
      <CurveSetting v-model="settingVisible" :propVisible="settingVisible" @set-success="setSuccess"></CurveSetting>
      <ExpulsionSetting v-model="expulsionSettingVisible" :propVisible="expulsionSettingVisible" @set-success="setExpulsionSuccess"></ExpulsionSetting>
      <WebSocket :url="webSocketUrl" @receive-message="receiveMessage"></WebSocket>
      <WarnList v-model="visiableError" :propVisible="visiableError" :errorData="warnData"></WarnList>
    </div>
  </MainLayout>
</template>

<script>
import { API_URL } from '@/constants/const';
import axios from 'axios';
import MainLayout from '@/components/MainLayout.vue'
import { Row, Col, Radio, Button, Card, Tabs, TabPane, Input } from "view-design"
import { mapGetters } from 'vuex'
import CurveSetting from './components/CurveSetting.vue';
import ExpulsionSetting from '@/components/ExpulsionSetting.vue';
import { setSidbarBreadCrumb, postJsError, setDashboardPage } from '@/util/util.js';
import NoAuth from '@/components/NoAuth.vue'
import WebSocket from '@/components/WebSocket.vue';
import WarnList from '@/components/WarnList.vue';
export default {
  name: 'RunningIndex',
  components: {
    MainLayout, Row, Col, Radio, Button, Card, Tabs, TabPane, Input, CurveSetting, ExpulsionSetting, NoAuth, WebSocket, WarnList
  },
  computed: {
    ...mapGetters(['getTranslation']),
    ValControllerHWVer() {
      return 'V' + this.version.ValControllerHWVer
    },
    ValControllerSWVer() {
      return 'V' + this.version.ValControllerSWVer
    },
    ValControllerCpldSWVer() {
      return 'V' + this.version.ValControllerCpldSWVer
    },
    CofGun1RogowskiSamp() {
      return 'V_' + this.version.CofGun1RogowskiSamp
    },
    mode1() {
      if (this.mode == 0 || this.mode == 1 || this.mode == 3 || this.mode == 4 || this.mode == 5 || this.mode == 6) {
        return true
      } else {
        return false
      }
    },
    mode2() {
      if (this.mode == 2) {
        return true
      } else {
        return false
      }
    },
    mode3() {
      if (this.mode == 0 || this.mode == 4 || this.mode == 6) {
        return true
      } else {
        return false
      }
    },
    mode4() {
      if (this.mode == 1 || this.mode == 2 || this.mode == 3 || this.mode == 5) {
        return true
      } else {
        return false
      }
    },
    mode5() {
      if (this.mode == 3) {
        return true
      } else {
        return false
      }
    },
    mode6() {
      if (this.mode == 6) {
        return true
      } else {
        return false
      }
    },
    webSocketUrl() {
      return API_URL['webSocket'] + "?mac=" + this.$route.query.mac;
    },

  },
  data() {
    return {
      mac: null,
      selectLibrary: {},
      selectTab: 'm1',
      kind: 803,
      OptMachineType: -1,
      version: {},
      yAxisDefine: [],
      myChart: null,
      chartWidth: '100%',
      settingVisible: false,
      inputStatus: null,
      outputStatus: null,
      mode: null,
      ValCurrentPhase: null, //进度
      modeLoadding: [false, false, false],
      gProdSpotCnt: -1,
      showWarn: false,
      hasAuth: true,
      warnData: {},
      visiableError: false,
      highlightPoint: -1, // x-axis position for highlight point
      expulsionPoint: null,
      expulsionSettingVisible: false,
      showExpulsionPoint: false,
      lastCurveData: null,
      hasReceiveMessage:false,

    }
  },
  mounted() {


  },
  created() {
    this.initChart();
    this.init();
    setDashboardPage('running');
  },

  beforeDestroy() {
  },
  methods: {
    // Get index on xAxis that matches highlightPoint; returns -1 if not found
    getHighlightIndex(xAxis) {
      if (this.highlightPoint < 0) return -1;
      if (!Array.isArray(xAxis)) return -1;
      // prefer exact match
      let idx = xAxis.findIndex(x => Number(x) === Number(this.highlightPoint));
      if (idx !== -1) return idx;
      // fallback to nearest numeric
      const target = Number(this.highlightPoint);
      let nearestIdx = -1;
      let minDiff = Infinity;
      xAxis.forEach((x, i) => {
        const v = Number(x);
        const d = Math.abs(v - target);
        if (!Number.isNaN(v) && d < minDiff) {
          minDiff = d;
          nearestIdx = i;
        }
      });
      
      return nearestIdx;
    },

    // Build markPoint config for a series at highlightPoint
    getMarkPoint(seriesData, xAxis, color) {
      const idx = this.getHighlightIndex(xAxis);
      if (
        idx < 0 ||
        !Array.isArray(seriesData) ||
        seriesData.length <= idx ||
        seriesData[idx] == null
      ) {        
        return { data: [] };
      }
      return {
        symbol: 'circle',
        symbolSize: 10,
        itemStyle: {
          color: '#fff',
          borderColor: color,
          borderWidth: 2
        },
        data: [{ coord: [xAxis[idx], seriesData[idx]] }]
      };
    },

    receiveMessage(obj) {
      if (obj && obj.kind) {
        switch (obj.kind) {
          case 'curve':
            this.hasReceiveMessage = true;
            //焊接波形
            this.expulsionPoint = obj.data.expulsionPoint||[];
            var aSeries = [];
            var aLegend = [];
            if (obj.data.curves.current) {
              aLegend.push(this.getTranslation('r081'));
              aSeries.push({
                name: this.getTranslation('r081'),
                type: 'line',
                tiled: '总量',
                showSymbol: false,
                // smooth: true,
                color: '#f00',
                lineStyle: { width: 1 },
                yAxisIndex: 0,
                data: obj.data.curves.current,                
              });
              this.yAxisDefine[0].show = true;
            } else {
              this.yAxisDefine[0].show = false;
              aSeries.push({
                type: 'line',
                name: this.getTranslation('r081'),
                data: []
              });
            }
            if (obj.data.curves.voltage) {
              aLegend.push(this.getTranslation('r082'));//电压
              aSeries.push({
                name: this.getTranslation('r082'),
                type: 'line',
                tiled: '总量',
                showSymbol: false,
                // smooth: true,
                color: '#00f',
                lineStyle: { width: 1 },
                yAxisIndex: 1,
                data: obj.data.curves.voltage,                
              });
              this.yAxisDefine[1].show = true;
            } else {
              this.yAxisDefine[1].show = false;
              aSeries.push({
                name: this.getTranslation('r082'),
                type: 'line',
                data: []
              });
            }
            if (obj.data.curves.resistance) {
              aLegend.push(this.getTranslation('r083'));//电阻
              const resistanceSeries = {
                name: this.getTranslation('r083'),
                type: 'line',
                tiled: '总量',
                showSymbol: false,
                // smooth: true,
                color: '#0f0',
                lineStyle: { width: 1 },
                yAxisIndex: 2,
                data: obj.data.curves.resistance,
                markPoint: {
                      data: []
                  }
              }
              aSeries.push(resistanceSeries);
              this.yAxisDefine[2].show = true;
              
              if (Array.isArray(this.expulsionPoint) && this.expulsionPoint.length > 0 && this.showExpulsionPoint) {
                        var anomalies = [];
                      for (let i = 0; i < this.expulsionPoint.length; i++) {
                          const pointIndex = Number(this.expulsionPoint[i]);
                          if (Number.isNaN(pointIndex) || pointIndex < 0 || pointIndex >= obj.data.curves.resistance.length) {
                              continue;
                          }
                          anomalies.push({
                              name: "飞溅发生点1",
                              value: obj.data.curves.resistance[pointIndex] || 0,
                              xAxis: pointIndex,
                              yAxis: obj.data.curves.resistance[pointIndex] || 0,
                              itemStyle: { color: '#e74c3c' },                                
                              
                          });
                      }
                      if (anomalies.length > 0) {
                          resistanceSeries.markPoint = {
                              data: anomalies,
                              name: "飞溅发生点2",
                              symbol: 'circle',
                              symbolSize: 8,
                              itemStyle: { color: '#e74c3c' },
                              label: { show: false },
                              
                          };
                      }

                  }

            } else {
              this.yAxisDefine[2].show = false;
              aSeries.push({
                name: this.getTranslation('r083'),
                type: 'line',
                data: []
              });
            }
            if (obj.data.curves.press) {
              aLegend.push(this.getTranslation('r084')); //压力
              aSeries.push({
                name: this.getTranslation('r084'),
                type: 'line',
                tiled: '总量',
                showSymbol: false,
                // smooth: true,
                color: '#FFA500',
                lineStyle: { width: 1 },
                yAxisIndex: 3,
                data: obj.data.curves.press,
                markPoint: this.getMarkPoint(obj.data.curves.press, obj.data.xAxis, '#FFA500')
              });
              this.yAxisDefine[3].show = true;
            } else {
              this.yAxisDefine[3].show = false;
              aSeries.push({
                name: this.getTranslation('r084'),
                type: 'line',
                data: []
              });
            }
            this.myChart.setOption({
              legend: {
                data: aLegend,
                bottom: 0
              },
              yAxis: this.yAxisDefine,
              xAxis: {
                axisLine: { onZero: true },
                type: 'category',
                boundaryGap: false,
                splitLine: {
                  show: true
                },
                data: obj.data.xAxis
              },
              series: aSeries
            });           
            break;
          case 'input':
            this.inputStatus = obj.data;
            break;
          case 'output':
            this.outputStatus = obj.data;
            break;
          case 'warnList':            
            if (obj.data.macId && obj.data.macId == this.mac) {
              if (obj.data.clear) {                
                this.showWarn = false;
              } else {
                this.showWarn = true;
              }
            }
            if (obj.data.alarms && obj.data.macId && obj.data.macId == this.mac) {
              this.warnData = obj.data;
            }
            break;

          case 'mode':
            //设备状态
            this.mode = obj.data.value;
            break;
          case 'weld':
            this.selectLibrary = obj.data
            this.ValCurrentPhase = obj.data.ValCurrentPhase
            if (this.gProdSpotCnt === -1) {
              this.gProdSpotCnt = obj.data.ValGun1TotalProdSpotCnt
              this.loadLastCurves(obj.data.ValGun1TotalProdSpotCnt)
            }
            break;
          default:
            break;
        }
      }
    },
    formatCurveTooltip(params) {
            const lines = [];
            const tooltipParams = Array.isArray(params) ? params : [params];
            if (!tooltipParams.length) {
                return '';
            }

            const firstPoint = tooltipParams[0];
            lines.push(firstPoint.axisValueLabel || firstPoint.name || '');
            tooltipParams.forEach((onePoint) => {
                const value = onePoint && onePoint.value !== undefined && onePoint.value !== null ? onePoint.value : '-';
                lines.push(`${onePoint.marker || ''}${onePoint.seriesName}: ${value}`);
            });

            const pointIndex = Number(firstPoint.dataIndex);
            const hasAnomaly = Array.isArray(this.expulsionPoint) && this.expulsionPoint.some((oneIndex) => Number(oneIndex) === pointIndex);
            if (hasAnomaly) {
                lines.push(this.getTranslation('m214')); // "飞溅发生"
            }

            return lines.join('<br/>');
        },
    async loadLastCurves(id) {
      let url = API_URL["recordLastCurve"];
      if (!this.mac) {
        this.$Message.error(this.getTranslation('m041'));
        return
      }
      let params = {
        mac: this.mac,
        id: id
      }
      let res = await axios.get(url, {
        params: params
      });


      if (res && res.data && res.data.code == 200) {
        this.lastCurveData = res.data.data;
        if(!this.hasReceiveMessage) {
          this.reChart()
        }
      }

    },
    reChart() {
      let e = this.lastCurveData;
      let aSeries = [];
      let aLegend = [];
      const xAxis = e.xAxis;
      this.expulsionPoint = e.expulsionPoint||[];
      if (e.curves.current) {
        aLegend.push(this.getTranslation('r081'));
        aSeries.push({
          name: this.getTranslation('r081'),
          type: 'line',
          tiled: '总量',
          showSymbol: false,
          // smooth: true,
          color: '#f00',
          lineStyle: { width: 1 },
          yAxisIndex: 0,
          data: e.curves.current,
          markPoint: this.getMarkPoint(e.curves.current, xAxis, '#f00')
        });
        this.yAxisDefine[0].show = true;
      } else {
        this.yAxisDefine[0].show = false;
        aSeries.push({
          type: 'line',
          name: this.getTranslation('r081'),
          data: []
        });
      }
      if (e.curves.voltage) {
        aLegend.push(this.getTranslation('r082'));//电压
        aSeries.push({
          name: this.getTranslation('r082'),
          type: 'line',
          tiled: '总量',
          showSymbol: false,
          // smooth: true,
          color: '#00f',
          lineStyle: { width: 1 },
          yAxisIndex: 1,
          data: e.curves.voltage,
          markPoint: this.getMarkPoint(e.curves.voltage, xAxis, '#00f')
        });
        this.yAxisDefine[1].show = true;
      } else {
        this.yAxisDefine[1].show = false;
        aSeries.push({
          name: this.getTranslation('r082'),
          type: 'line',
          data: []
        });
      }
      if (e.curves.resistance) {
        aLegend.push(this.getTranslation('r083'));//电阻
        const resistanceSeries ={
          name: this.getTranslation('r083'),
          type: 'line',
          tiled: '总量',
          showSymbol: false,
          // smooth: true,
          color: '#0f0',
          lineStyle: { width: 1 },
          yAxisIndex: 2,
          data: e.curves.resistance,
           markPoint: {
                      data: []
                  }
        }
        aSeries.push(resistanceSeries);
        this.yAxisDefine[2].show = true;        
         if (Array.isArray(this.expulsionPoint) && this.expulsionPoint.length > 0 && this.showExpulsionPoint) {
                var anomalies = [];
              for (let i = 0; i < this.expulsionPoint.length; i++) {
                  const pointIndex = Number(this.expulsionPoint[i]);
                  if (Number.isNaN(pointIndex) || pointIndex < 0 || pointIndex >= e.curves.resistance.length) {
                      continue;
                  }
                  anomalies.push({
                      name: "飞溅发生点1",
                      value: e.curves.resistance[pointIndex] || 0,
                      xAxis: pointIndex,
                      yAxis: e.curves.resistance[pointIndex] || 0,
                      itemStyle: { color: '#e74c3c' },                                
                      
                  });
              }
              if (anomalies.length > 0) {
                  resistanceSeries.markPoint = {
                      data: anomalies,
                      name: "飞溅发生点2",
                      symbol: 'circle',
                      symbolSize: 8,
                      itemStyle: { color: '#e74c3c' },
                      label: { show: false },
                      
                  };
              }

          }


      } else {
        this.yAxisDefine[2].show = false;
        aSeries.push({
          name: this.getTranslation('r083'),
          type: 'line',
          data: []
        });
      }
      if (e.curves.press) {
        aLegend.push(this.getTranslation('r084')); //压力
        aSeries.push({
          name: this.getTranslation('r084'),
          type: 'line',
          tiled: '总量',
          showSymbol: false,
          // smooth: true,
          color: '#FFA500',
          lineStyle: { width: 1 },
          yAxisIndex: 3,
          data: e.curves.press,
          markPoint: this.getMarkPoint(e.curves.press, xAxis, '#FFA500')
        });
        this.yAxisDefine[3].show = true;
      } else {
        this.yAxisDefine[3].show = false;
        aSeries.push({
          name: this.getTranslation('r084'),
          type: 'line',
          data: []
        });
      }
      this.myChart.setOption({
        legend: {
          data: aLegend,
          bottom: 0
        },
        yAxis: this.yAxisDefine,
        xAxis: {
          axisLine: { onZero: true },
          type: 'category',
          boundaryGap: false,
          splitLine: {
            show: true
          },
          data: xAxis
        },
        series: aSeries
      });    
    },
    init() {
      this.mac = this.$route.query.mac
      this.showExpulsionPoint = localStorage.getItem('running.showExpulsionPoint') != '0';
      this.getInfo()
    },
    getInfo() {
      let url = API_URL["runningInit"];
      if (!this.mac) {
        this.$Message.error(this.getTranslation('m041'));
        return
      }
      let params = {
        mac: this.mac,
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.OptMachineType = res.data.data.OptMachineType;
            this.kind = res.data.data.kind;
            this.version = res.data.data.version;
            this.$store.commit('setBreadcrumbItems', [
              { title: setSidbarBreadCrumb(res.data.data.machine), machine: res.data.data.machine }
            ]);
          } else if (res && res.data && res.data.code == 3001) {
            this.hasAuth = false;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    curveSetting() {
      this.settingVisible = true;
    },
    expulsionSetting(){
      this.expulsionSettingVisible = true;
    },
    initChart() {
      this.$nextTick(() => {
        const parentWidth = this.$refs.runningEcharts.offsetWidth;
        this.chartWidth = `${parentWidth}px`;
        this.myChart = this.$echarts.init(this.$refs.runningEcharts);
        this.yAxisDefine = [
          {
            name: this.getTranslation('r081'),
            show: true,
            offset: 0,
            position: 'left',
            nameLocation: 'middle',
            axisLine: { onZero: true },
            type: 'value'
          },
          {
            name: this.getTranslation('r082'),
            show: true,
            offset: 0,
            position: 'right',
            nameLocation: 'middle',
            axisLine: { onZero: true },
            type: 'value'
          },
          {
            name: this.getTranslation('r083'),
            show: true,
            offset: 10,
            position: 'left',
            nameLocation: 'middle',
            axisLine: { onZero: true },
            type: 'value'
          },
          {
            name: this.getTranslation('r084'),
            show: true,
            offset: 10,
            position: 'right',
            nameLocation: 'middle',
            axisLine: { onZero: true },
            type: 'value'
          }
        ];
        var _this = this;
        // 使用刚指定的配置项和数据显示图表。
        this.myChart.setOption({
          title: { text: "weld-curve", show: false },
          toolbox: {
            feature: {
              myTool1: {
                show: true,
                title: this.getTranslation('r085'),//采集设置
                icon: 'image://' + require('@/assets/img/chart-setting.png'),
                onclick: function () {
                  _this.curveSetting();
                },
              },
              myTool2: {
                show: true,
                title: this.getTranslation('r118'),//飞溅点设置
                icon: 'path://M512 192C282.8 192 85.3 328.5 0 512c85.3 183.5 282.8 320 512 320s426.7-136.5 512-320C938.7 328.5 741.2 192 512 192z M512 746.7c-129.8 0-234.7-104.9-234.7-234.7S382.2 277.3 512 277.3 746.7 382.2 746.7 512 641.8 746.7 512 746.7z M512 384c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128S582.7 384 512 384z',
                onclick: function () {
                  _this.expulsionSetting();
                },
              },

              saveAsImage: {
                show: true
              }
            }
          },
          tooltip: {
            trigger: 'axis',
            formatter: (params) => this.formatCurveTooltip(params)
          },
          grid: {
            left: '35px',
            right: '45px',
            top: '40px',
          },
          yAxis: this.yAxisDefine,
          dataZoom: [
            {
              id: 'dataZoomX',
              type: 'slider',
              xAxisIndex: 0,
              bottom: 30,
              filterMode: 'empty',
              showDataShadow: true,
              start: 0,
              end: 100
            },
            {
              type: 'slider',
              xAxisIndex: 0,
              bottom: 30,
              filterMode: 'empty',
              showDataShadow: true
            },
            {
              type: 'slider',
              yAxisIndex: [0, 1, 2, 3],
              right: 0,
              filterMode: 'empty',
              showDataShadow: true
            },
          ],          
          xAxis: {
            data: []
          },
          legend: {
            data: []
          },
          series: [{
            name: this.getTranslation('r081'),
            type: 'line',
            data: []
          }],
          graphic: [
            {
              id: 'selectionRect',
              type: 'rect',
              invisible: true,
              // make the selection overlay not intercept pointer events
              silent: true,
              shape: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
              },
              style: {
                fill: 'rgba(135, 206, 250, 0.3)',
                stroke: '#1E90FF',
                lineWidth: 1
              },
              z: 100
            }
          ]
        });
        this.setBrush();
      })
       

    },
    setBrush() {
      // 确保移除之前的事件监听器
      this.myChart.getZr().off('mousedown');
      //this.myChart.getZr().off('mousemove');
      this.myChart.getZr().off('mouseup');
      this.myChart.getZr().off('dblclick');

      // 绑定事件
      const zr = this.myChart.getZr();

      zr.on('mousedown', (e) => {
        if (e.event.which !== 1) return; // only left button

        // only activate brush inside the grid, ignore clicks on toolbox and elsewhere
        const inGrid = this.myChart.containPixel({ gridIndex: 0 }, [e.offsetX, e.offsetY]);
        if (!inGrid) return;

        this.isSelecting = true;
        this.startPos = { x: e.offsetX, y: e.offsetY };

        const gridModel = this.myChart.getModel().getComponent('grid', 0);
        if (gridModel) {
          const grid = gridModel.coordinateSystem;
          const rect = grid.getRect();

          this.myChart.setOption({
            graphic: {
              id: 'selectionRect',
              invisible: false,
              shape: {
                x: this.startPos.x,
                y: rect.y,
                width: 0,
                height: rect.height
              }
            }
          });
        }
      });

      zr.on('mousemove', (e) => {
        if (this.isSelecting && this.startPos) {
          const width = e.offsetX - this.startPos.x;
          this.myChart.setOption({
            graphic: {
              id: 'selectionRect',
              shape: { width }
            }
          });
        }
      });

      zr.on('mouseup', (e) => {
        if (this.isSelecting && this.startPos) {
          this.isSelecting = false;

          const endPos = { x: e.offsetX, y: e.offsetY };
          const width = Math.abs(endPos.x - this.startPos.x);

          if (width > 10) {
            this.applyZoom(this.startPos.x, endPos.x);
          }

          this.myChart.setOption({
            graphic: {
              id: 'selectionRect',
              invisible: true
            }
          });

          this.startPos = null;
        }
      });

      zr.on('dblclick', (e) => {
        // only reset zoom when double-click happens inside the grid
        const inGrid = this.myChart.containPixel({ gridIndex: 0 }, [e.offsetX, e.offsetY]);
        if (!inGrid) return;

        this.myChart.dispatchAction({
          type: 'dataZoom',
          dataZoomId: 'dataZoomX',
          start: 0,
          end: 100
        });
      });
    },

    applyZoom(startPixel, endPixel) {
      const xAxis = this.myChart.getModel().getComponent('xAxis', 0);
      if (!xAxis) return;

      const axis = xAxis.axis;
      const pixelExtent = axis.getGlobalExtent();
      const minX = Math.min(startPixel, endPixel);
      const maxX = Math.max(startPixel, endPixel);

      // 确保在轴范围内
      const clampedMin = Math.max(minX, pixelExtent[0]);
      const clampedMax = Math.min(maxX, pixelExtent[1]);

      if (clampedMax <= clampedMin) return;

      // 计算百分比
      const startPercent = (clampedMin - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;
      const endPercent = (clampedMax - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;

      this.myChart.dispatchAction({
        type: 'dataZoom',
        dataZoomId: 'dataZoomX',
        start: startPercent,
        end: endPercent
      });


    }, 

  
    setSuccess() {

    },
    setExpulsionSuccess() {
      this.showExpulsionPoint = localStorage.getItem('running.showExpulsionPoint') != '0';
      this.reChart();
      
    },
    toAlarm() {
      this.$router.push({
        path: '/alarm',
        query: {
          mac: this.mac
        }
      })
    },
    async workMode() {
      this.$set(this.modeLoadding, 0, true);
      await this.handleWeldMode("work-fix");
      this.$set(this.modeLoadding, 0, false);
    },
    async weldMode() {
      this.$set(this.modeLoadding, 1, true);
      await this.handleWeldMode("weld-check");
      this.$set(this.modeLoadding, 1, false);
    },
    async pressMode() {
      this.$set(this.modeLoadding, 2, true);
      await this.handleWeldMode("press-weld");
      this.$set(this.modeLoadding, 2, false);
    },
    async handleWeldMode(kind) {
      let url = API_URL["runningOperate"];
      if (!this.mac) {
        this.$Message.error(this.getTranslation('m041'));
        return
      }
      let params = {
        mac: this.mac,
        kind: kind,
      }
      await axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code != 200 && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    getIOClass(val, isWorkMode = false) {
      let cls = 'custom-default';
      if (isWorkMode) {
        if (val) {
          cls = 'custom-primary'
        } else {
          cls = 'custom-warn'
        }
      } else {
        if (val) {
          cls = 'custom-error'
        }
      }
      return cls
    },
    showWarnList() {

      if (this.showWarn) {
        this.visiableError = true;
      }
    }
  }
}
</script>

<style scoped>
@import url('../../assets/style/list.css');
@import url('../../assets/style/tab.css');

/* 针对 disabled Input 组件的样式 */
::v-deep(.ivu-input.ivu-input-disabled),
::v-deep(.ivu-input[disabled]) {
  color: #999 !important;
  background-color: #f8f9fa !important;
  border-color: #ced4da !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #999 !important;
}

.status-bar {
  margin-bottom: 16px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.status-title {
  font-size: 16px;
  color: #495057;
}

.compact-radio {
  margin-bottom: 8px;
}

.compact-radio .ivu-radio-wrapper {
  margin-right: 12px;
  margin-bottom: 4px;
}

.action-btn {
  margin-top: 4px;
}

.warning-status {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #dc3545;
  font-weight: 500;
}

.spec-row {
  margin-bottom: 16px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.spec-content {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  /* 垂直间距 8px，水平间距 12px */
  align-items: center;
}

.spec-item {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.spec-input {
  margin: 0 4px;
}

.bordered-section {
  border-radius: 6px;
  padding: 0px;
  margin: 0px 0;
  background: #ffffff;
}

.vin-section {
  margin-top: 0px;
}

.vin-header,
.vin-data {
  padding: 0 0;

}

.vin-header {
  background: #f8f9fa;
}

.vin-cell {
  border: 1px solid #dee2e6;
  padding: 4px 4px;
  text-align: center;
  min-height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vin-cell:last-child {
  border-right: 1px solid #dee2e6;
}

.other-img {
  width: 17px;
}

.radio-buttons-row {
  display: flex;

  justify-content: center;
  /* 居中对齐按钮 */
  margin-left: 10px;

}


.radio-buttons-row .ivu-radio-wrapper {
  font-size: 0;
  /* 隐藏默认的label文本 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.radio-buttons-row .ivu-radio-wrapper::after {
  content: '';
  /* 移除可能存在的伪元素内容 */
}

.radio-labels-row {
  display: flex;
  justify-content: center;
  font-size: 12px;
  color: #515a6e;
}

.radio-buttons-col {
  border: 1px solid #dee2e6;
  padding: 4px;
}

.my-custom-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 4px;
}

.custom-default {
  background-color: #e6ebf1;
}

.custom-error {
  background-color: #ed4014;
}

.custom-warn {
  background-color: #ff9900;
}

.custom-primary {
  background-color: #19be6b;
}

.custom-label {
  display: inline-block;
}

.label-custom-warn {
  color: #ff9900
}

.label-custom-primary {
  color: #19be6b
}

.little-card {
  font-size: 14px;
}

.normal-row {
  margin-bottom: 5px;
}

.custom-radio-checked /deep/ .ivu-radio-inner {
  border-color: #19be6b !important;
  background-color: #19be6b !important;
}

.custom-radio-checked /deep/ .ivu-radio-inner:after {
  border-color: #fff !important;
}

.custom-radio-unchecked /deep/ .ivu-radio-inner {
  border-color: #dcdee2 !important;
  background-color: #f7f7f7 !important;
}

.ivu-radio-disabled {
  cursor: not-allowed !important;
}

.in-progroess {
  background-color: #00f;
  color: #fff;
}
.chart-tip{
  margin-top:-10px;
  margin-bottom: 0px;
  color: #888;
}
</style>